module.exports = __webpack_public_path__ + "../../static/vue/img/trainer_512.f5b64c46.jpg";